import { useQuery } from '@tanstack/react-query';
import { IFilterCategory } from '@legacy/apis/types/filterListAPI';
import { getFetch } from '@legacy/utils/fetcher';

const FILTER_URL_PATH = (pageIdentifier: string) =>
  `/api/v2/filters/list/${pageIdentifier}`;

export const FILTER_MSW_STATUS_KEY = 'filterAPI';

export const FILTER_KEY = 'FILTER';

export const useGetFilterAPI = (pageIdentifier: string, enableFetch = true) => {
  const filterFetch = (): Promise<IFilterCategory> =>
    getFetch({
      path: FILTER_URL_PATH(pageIdentifier),
      key: FILTER_MSW_STATUS_KEY,
    });

  const { data, ...restProps } = useQuery({
    queryKey: [`${FILTER_KEY}_${pageIdentifier}`],
    queryFn: filterFetch,
    enabled: !!pageIdentifier && enableFetch,
  });

  return {
    filterList:
      data?.entities?.map(({ properties = {} }) => ({
        ...properties,
      })) || [],
    ...restProps,
  };
};
